<template>
  <div class="asidPart">
    <div class="navPart">
      <div class="navTitle">Journals</div>
      <!-- <div class="navItem">All</div> -->
      <ul class="filterLetters">
        <li
          v-for="(letter, index) in letters"
          :key="index"
          @click="changeJournalsPage(letter)"
          :class="{ letterStyle: letter == keyword }"
        >
          {{ letter }}
        </li>
      </ul>
    </div>
    <div class="navPart" v-if="false">
      <router-link
        class="navItem"
        v-for="(item, index) in asidNavList"
        :key="index"
        @click.native="changePage(item.url)"
        :class="{ select: item.url == path }"
        :to="item.url"
      >
        <i class="iconfont"></i>
        <span>{{ item.navItem }}</span>
      </router-link>
    </div>
    <div class="navPart">
      <div class="navTitle">News & Announcements</div>
      <!-- @click="toAnnouncementsDetail(item)" -->
      <div class="newsItem" v-for="(item, index) in list" :key="index">
        <div class="newsDate">
          <i class="el-icon-date"></i>
          {{ item.datePosted }}
        </div>
        <div class="newsTitle">
          <a :href="newsLink(item)">{{ item.title }}</a>
        </div>
        <!-- <div class="newsDetail">
          <span class="commonText commonTexts">detail>></span>
        </div> -->
      </div>
      <div class="more">
        <span @click="toAnnouncementsList">
          more <i class="el-icon-d-arrow-right"></i>
        </span>
      </div>
    </div>
    <div class="navPart"></div>
  </div>
</template>

<script>
import announcementsFun from "@/mixins/announcementsFun.js";
import { newsLink } from "@/utils/addLink";
export default {
  props: ["content"],
  mixins: [announcementsFun],
  data() {
    return {
      asidNavList: [
        { navItem: "For authors", url: "/forAuthors" },
        { navItem: "For reviewers", url: "/forReviewers" },
        { navItem: "For editors", url: "/forEditors" },
      ],
      path: "",
      classList: [],
      letters: this.generateLetters(),
      keyword: "",
    };
  },
  mounted() {
    this.path = window.location.pathname;
    let item = this.asidNavList.find((obj) => obj.url == this.path);
    if (item == false) {
      this.path = "/";
    }
  },
  methods: {
    newsLink,
    generateLetters() {
      const letters = [];
      for (let i = 0; i < 26; i++) {
        letters.push(String.fromCharCode(65 + i));
      }
      letters.unshift("All");
      return letters;
    },
    changeJournalsPage(item) {
      this.keyword = item;
      if (this.$route.name === "journalList") {
        let keyword = item == "All" ? "" : item;
        this.$emit("handleSearch", keyword);
      } else {
        this.$router.push({
          path: "/journalList",
        });
      }
    },
    changePage(path) {
      this.path = path;
    },
    toAnnouncementsList() {
      this.$router.push({
        path: "/announcementsList",
      });
      window.scrollTo(0, 0);
    },
    toAnnouncementsDetail(item) {
      this.$router.push({
        name: "announcementsDetail",
        query: {
          detailUrl: item.url,
        },
      });
    },
  },
};
</script>

<style lang="less" scoped>
.asidPart {
  width: 100%;
  .navPart {
    background: #fff;
    font-size: 14px;
    margin-bottom: 20px;
    border: 1px solid #ebeef5;
    border-radius: 8px;
    padding: 0 20px;
    .navTitle {
      width: 100%;
      padding: 10px 0px;
      line-height: 28px;
      font-size: 14px;
      color: #293150;
      font-weight: bolder;
    }
    .filterLetters {
      display: flex;
      justify-content: flex-start;
      align-items: center;
      flex-wrap: wrap;
      padding-bottom: 10px;
      li {
        width: 20px;
        height: 20px;
        border: 1px solid;
        line-height: 20px;
        text-align: center;
        list-style: none;
        margin: 2px;
        padding: 1px;
        cursor: pointer;
        color: #7b7b7b;
        border-radius: 4px;
        &:hover {
          background-image: -webkit-gradient(
            linear,
            left bottom,
            left top,
            color-stop(0, #64b5f6),
            color-stop(1, #1e88e5)
          );
          color: #fff;
          transition: all 0.6s;
        }
      }
      .letterStyle {
        // background: #f68111;
        background-image: -webkit-gradient(
          linear,
          left bottom,
          left top,
          color-stop(0, #64b5f6),
          color-stop(1, #1e88e5)
        );
        color: #fff;
        padding: 2px;
      }
    }
    .navItem {
      display: inline-block;
      width: 100%;
      height: 45px;
      line-height: 45px;
      border-bottom: 1px dashed #e4e4e4;
      cursor: pointer;
      transition: all 0.6s;
      color: #7b7b7b;
      .iconfont {
        width: 7px;
        height: 7px;
        display: inline-block;
        border-radius: 100%;
        background: #098acc;
        box-shadow: 2px 2px 4px rgb(0 0 0 / 20%),
          -2px -2px 4px rgb(255 255 255 / 40%);
      }
      span {
        margin-left: 10px;
        transition: margin-left 0.6s;
      }
      &:last-child {
        border-bottom: none;
      }
      &:hover {
        color: #098acc;
        span {
          margin-left: 17px;
          transition: margin-left 0.6s;
        }
      }
    }
    .select {
      color: #098acc;
    }
    .newsItem {
      font-size: 14px;
      color: #7b7b7b;
      padding-bottom: 10px;
      margin-bottom: 20px;
      border-bottom: 1px dashed #e4e4e4;
      .newsDate {
        margin-bottom: 5px;
      }
      .newsTitle {
        line-height: 23px;
        width: 100%;
        cursor: pointer;
        &:hover {
          color: #098acc;
          text-decoration: underline;
          transition: all 0.6s;
        }
      }
      .newsDetail {
        text-align: right;
        cursor: pointer;
      }
    }
    .more {
      width: 100%;
      padding: 5px 0;
      text-align: center;
      border-radius: 3px;
      color: #666;
      cursor: pointer;
      transition: all 0.6s;
      margin-bottom: 10px;
      // background-image: -webkit-gradient(
      //   linear,
      //   left bottom,
      //   left top,
      //   color-stop(0, #64b5f6),
      //   color-stop(1, #1e88e5)
      // );
      border-radius: 8px;
      i {
        transform: rotate(90deg);
      }
    }
    .more:hover {
      transition: all 0.6s;
      color: #ffffff;
      background-image: -webkit-gradient(
        linear,
        left bottom,
        left top,
        color-stop(0, #64b5f6),
        color-stop(1, #1e88e5)
      );
    }
  }
}
</style>
